/* eslint-disable max-len */
import React from 'react';

const CBGIcon = (props) => (
  <svg width='70' height='43' viewBox='0 0 70 43' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M37.0484 8.0786C38.2544 8.0786 39.1364 7.2146 39.1364 6.0086C39.1364 4.8026 38.2544 3.9386 37.0484 3.9386C35.8364 3.9386 34.9544 4.8026 34.9544 6.0086C34.9544 7.2146 35.8364 8.0786 37.0484 8.0786ZM37.0484 7.3226C36.3044 7.3226 35.8304 6.7526 35.8304 6.0086C35.8304 5.2586 36.3044 4.6946 37.0484 4.6946C37.7864 4.6946 38.2604 5.2586 38.2604 6.0086C38.2604 6.7526 37.7864 7.3226 37.0484 7.3226Z'
      fill='#4F5D68'
    />
    <path
      d='M43.3342 8.0066V4.0046H42.4762V5.5766H40.5862V4.0046H39.7342V8.0066H40.5862V6.3206H42.4762V8.0066H43.3342Z'
      fill='#4F5D68'
    />
    <path
      d='M22.7464 32.0066V28.0046H21.8884V29.5766H19.9984V28.0046H19.1464V32.0066H19.9984V30.3206H21.8884V32.0066H22.7464Z'
      fill='#4F5D68'
    />
    <path
      d='M25.437 32.0786C26.643 32.0786 27.525 31.2146 27.525 30.0086C27.525 28.8026 26.643 27.9386 25.437 27.9386C24.225 27.9386 23.343 28.8026 23.343 30.0086C23.343 31.2146 24.225 32.0786 25.437 32.0786ZM25.437 31.3226C24.693 31.3226 24.219 30.7526 24.219 30.0086C24.219 29.2586 24.693 28.6946 25.437 28.6946C26.175 28.6946 26.649 29.2586 26.649 30.0086C26.649 30.7526 26.175 31.3226 25.437 31.3226Z'
      fill='#4F5D68'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.7297 13.5108V8.94801H14.7297V13.5007L19.9322 16.7956L26.5393 12.8726L32.5217 16.7921L37.7297 13.7362V9.30883H39.7297V13.751L45.6576 17.4108V24.3841L50.6203 27.0794L56.6657 23.5658L63.2496 27.3599L62.2511 29.0928L56.67 25.8766L50.6535 29.3733L44.6599 26.1182L38.2404 29.6385L32.464 26.1315L28.5871 28.2295L27.6352 26.4706L31.4926 24.3831V18.509L26.4872 15.2295L19.8984 19.1416L13.7389 15.2406L8.75035 18.509V24.406L14.7297 27.9111V35.0944L18.9346 37.2882L18.0094 39.0614L13.7173 36.822L9.99725 38.6591L9.11169 36.8658L12.7297 35.0791V29.057L6.75035 25.5519V17.4283L12.7297 13.5108ZM33.4926 18.5413V24.4162L38.2912 27.3296L43.6576 24.3868V18.5265L38.7166 15.476L33.4926 18.5413Z'
      fill='#64737F'
    />
  </svg>
);

export default CBGIcon;
